import script from "./FileTypeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileTypeModal.vue?vue&type=script&setup=true&lang=ts"

import "./FileTypeModal.vue?vue&type=style&index=0&id=0e8c0cea&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8c0cea"]])

export default __exports__